import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Typography,
  Paper,
  TextareaAutosize,
  Divider,
} from "@material-ui/core";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import { createPost, updatePost } from "../../actions/posts";
import { useHistory } from "react-router-dom";
import { START_LOADING, END_LOADING } from "../../constants/actionType";
import useStyles from "./style";
import FileBase from "react-file-base64";

import Resizer from "react-image-file-resizer";

const Form = ({ setCurrentId, currentId }) => {
  const [postData, setPostData] = useState({
    title: "",
    message: "",
    tags: "",
    selectedFile: "",
  });

  const dispatch = useDispatch();
  const history = useHistory();
  const post = useSelector((state) =>
    currentId ? state.posts.posts.find((p) => p._id === currentId) : null
  );
  const classes = useStyles();
  const user = JSON.parse(localStorage.getItem("profile"));
  useEffect(() => {
    if (post) setPostData(post);
  }, [post]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (currentId) {
      dispatch(
        updatePost(currentId, { ...postData, name: user?.result?.name })
      );
    } else {
      if (
        postData.title &&
        postData.message &&
        postData.tags &&
        postData.selectedFile
      ) {
        dispatch(
          createPost({ ...postData, name: user?.result?.name }, history)
        );
      } else {
        return toast.warn("You must fill in all the fields!", {});
      }
    }
    clear();
  };

  const clear = () => {
    setCurrentId(null);
    setPostData({
      title: "",
      message: "",
      tags: "",
      selectedFile: "",
    });
  };

  const resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        512,
        512,
        "JPEG",
        100,
        0,
        (uri) => {
          resolve(uri);
        },
        "base64"
      );
    });

  const onChange = async (event) => {
    dispatch({ type: START_LOADING });
    let imgArr = [];
    let obj = event.target.files;
    for (let i = 0; i < obj.length; i++) {
      try {
        const file = obj[i];
        const image = await resizeFile(file);
        imgArr.push(image);
      } catch (err) {
        console.log(err);
      }
    }
    console.log(imgArr);
    setPostData({ ...postData, selectedFile: JSON.stringify(imgArr) });
    dispatch({ type: END_LOADING });
  };

  if (!user?.result?.name) {
    return (
      <Paper elevation={8} className={classes.paper}>
        <Typography variant="h6" alignItems="center">
          Please Sign In to create your own reviews and like other's reviews.
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper elevation={8} className={classes.paper}>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <form
        className={classes.form}
        noValidate
        autoComplete="off"
        onSubmit={handleSubmit}
      >
        <Typography variant="h6">
          {!currentId ? "Creating" : "Editing"} a Review
        </Typography>
        <TextField
          required
          className={classes.textField}
          name="title"
          label="Title"
          fullWidth
          value={postData.title}
          onChange={(e) => setPostData({ ...postData, title: e.target.value })}
        />
        <TextField
          required
          className={classes.textField}
          name="tags"
          label="Tags"
          fullWidth
          value={postData.tags}
          onChange={(e) =>
            setPostData({ ...postData, tags: e.target.value.split(",") })
          }
        />
        <textarea
          required
          key="Message"
          id="outlined-required"
          className={classes.Textarea}
          name="message"
          placeholder="Message"
          fullWidth
          value={postData.message}
          onChange={(e) =>
            setPostData({ ...postData, message: e.target.value })
          }
        />
        <Divider className={classes.divider} variant="inset" component="h1" />{" "}
        <div className={classes.fileInput}>
          <input
            required
            className="form-control"
            type="file"
            id="formFileMultiple"
            multiple
            onChange={onChange}
          />
        </div>
        <Button
          className={classes.buttonSubmit}
          variant="contained"
          color="primary"
          size="large"
          type="submit"
          fullWidth
        >
          Submit
        </Button>
        <Button
          className={classes.buttonSubmit}
          variant="contained"
          color="secondary"
          size="small"
          onClick={clear}
          fullWidth
        >
          Clear
        </Button>
      </form>
    </Paper>
  );
};
export default Form;
